define('plugin/invoice/view/InvoicePaymentSystemItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Payment system info view (payment system item)
     *
     * @class PaidEventsItemView
     */
    return LayoutView.extend({

        template: '#invoice_payment_system_item_view',
        events: {
            'click': 'onClick'
        },
        modelEvents: {
            'change': 'render'
        },
        type: 'paymentSystem',

        onClick: function () {
            this.triggerMethod('payment_processor:select', {model: this.model, type: this.type});
        }

    });

});
